import api from './client';

const downloadReport = async (endpoint: string, params: Record<string, string>): Promise<Blob> => {
  try {
    const response = await api.get(endpoint, {
      params,
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });

    // Verify that we received a blob with the correct type
    if (!(response instanceof Blob) || !response.type.includes('spreadsheetml')) {
      throw new Error('Invalid response format');
    }

    return response;
  } catch (error) {
    console.error('Report download error:', error);
    throw error;
  }
};

export const downloadRegistrationsReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/registrations', { startDate, endDate });
};

export const downloadCouponsIssuedReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/coupons/issued', { startDate, endDate });
};

export const downloadCouponsRedeemedReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/coupons/redeemed', { startDate, endDate });
};

export const downloadCouponsExpiredReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/coupons/expired', { startDate, endDate });
};

export const downloadSupportTicketsReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/support-tickets', { startDate, endDate });
};

export const downloadBotUsageReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/bot-usage', { startDate, endDate });
};

export const downloadUserUsageReport = async (userId: string, startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/user-usage', { userId, startDate, endDate });
};

export const downloadCreditsReport = async (startDate: string, endDate: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/credits', { startDate, endDate });
};

export const downloadCreditsCarriedForwardReport = async (date: string): Promise<Blob> => {
  return downloadReport('/api/admin/reports/balance/carried-forward', { date });
};

export default {
  downloadRegistrationsReport,
  downloadCouponsIssuedReport,
  downloadCouponsRedeemedReport,
  downloadCouponsExpiredReport,
  downloadSupportTicketsReport,
  downloadBotUsageReport,
  downloadUserUsageReport,
  downloadCreditsReport,
  downloadCreditsCarriedForwardReport
};